'use client';

import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { isLightColor } from '../../utils/colors';
import styles from './DonateButton.module.scss';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';

type DonateButtonProps = {
  id?: string;
  className?: string;
  colorVariant?: 'brand' | 'primary';
  as?: React.ElementType;
  onClick: (event: React.MouseEvent) => void;
} & PropsWithChildren;

export const DonateButton: React.FC<DonateButtonProps> = ({
  id,
  children,
  className,
  colorVariant = 'primary',
  as = 'a',
  onClick,
}) => {
  const { t } = useTranslation();
  const { url, status, branding } = usePage();
  const isDonateActive = status === 'ACTIVE';
  const isPrimaryBrandColorLight = branding.primaryColor
    ? isLightColor(branding.primaryColor)
    : false;
  const isButton = as === 'button'  

  const Element = as;

  if (!isDonateActive) {
    return (
      <>
        <div className={classNames('cp-btn w-full', styles.disabled)}>
          <span aria-hidden>{children}</span>
          <span className="cp-sr-only">{t('common.donateButtonInactive')}</span>
        </div>
      </>
    );
  }

  return (
    <>
      <Element
        className={classNames(
          'cp-btn w-full branded-text-neutral',
          {
            ['cp-btn-primary']:
              colorVariant === 'primary' && !isPrimaryBrandColorLight,
            ['cp-btn-brand']:
              colorVariant === 'brand' && !isPrimaryBrandColorLight,
            ['cp-btn-secondary']: isPrimaryBrandColorLight,
          },
          className,
        )}
        href={!isButton ?`${url}/donate` : undefined}
        onClick={onClick}
        id={id}
      >
        {children}
      </Element>
    </>
  );
};
